<template>
  <v-flex
    v-if="!loading"
  >
  <div>
    <v-container fill-height fluid>
    <v-row>
      <v-flex xs3 class="mr-2">
        <Search
          v-model="filters.search"
          :label="$t('SEARCH')"
          prepend-icon="search"
          :delay="500"
        />
      </v-flex>
      <v-spacer></v-spacer>
    </v-row>
    </v-container>
    <v-data-table
      v-model="schoolSelected"
      :single-select="false"
      show-select
      item-key="id"
      :headers="headers"
      :items="items"
      :server-items-length="totalItems"
      :no-data-text="$t('NO_DATA')"
      :no-results-text="$t('NO_DATA')"
      hide-default-footer
      :options.sync="pagination"
      :loading="loading"
      class="elevation-1"
    >
      <template v-slot:item.code="{ item }">
          <pre>{{ item.code }}</pre>
      </template>
    </v-data-table>
    <div class="pt-2">{{$t('fields.total_items')}} {{ totalItems }}</div>
    <Paginator
      :total-items="totalItems"
      :page.sync="pagination.page"
      :items-per-page.sync="pagination.itemsPerPage"
      @change="fetchSchools"
    />
  </div>
  </v-flex>
  <Loader v-else/>
</template>

<script>
  import { mapActions } from 'vuex';

  import { propagandistsSchoolsService } from '../../../utils/services/propagandistsSchools.service';
  import Search from '../../shared/Inputs/Search';
  import Loader from '../../shared/Loader';
  import Paginator from '../../shared/Paginator';

  export default {
    name: 'SchoolSelection',
    components: { Search, Loader, Paginator },
    props: {
      perPage: {
        type: Number,
        default: 5,
      },
      propagandistId: {
        type: Number,
        default: 0,
      },
    },
    data() {
      return {
        loading: false,
        items: [],
        schoolSelected: [],
        totalItems: 0,
        pagination: {
          page: 1,
          itemsPerPage: this.perPage,
          sortDesc: [false],
          sortBy: ['schools.name'],
        },
        headers: [
          { text: this.$t('fields.school'), value: 'school_name' },
          { text: this.$t('fields.school_code'), value: 'school_code' },
          { text: this.$t('fields.city'), value: 'city' },
        ],
        filters: {
          search: null,
        },
      };
    },
    computed: {
      requestFilters() {
        const filters = {
          search: this.filters.search,
        };
        if (this.pagination.sortBy.length === 1 && this.pagination.sortDesc.length === 1) {
          const { sortBy, sortDesc } = this.pagination;
          filters.sortBy = sortBy;
          filters.sortDesc = sortDesc;
        }

        return filters;
      },
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('modal', ['showModal', 'hideModal']),
      ...mapActions('alert', ['showToast']),
      async fetchSchools(forcePage) {
        this.loading = true;
        const { page, itemsPerPage } = this.pagination;
        return propagandistsSchoolsService.index(this.propagandistId, {
          page: page || forcePage || 1,
          itemsPerPage,
          filters: this.requestFilters,
        })
          .then(response => {
            this.items = response.data.data;
            this.totalItems = response.data.meta.total;
            this.pagination = this.getPagination(
              response.data.meta,
              { oldPagination: this.pagination, forcePage },
            );
          })
          .catch(error => {
            this.handleError(error, this.errors);
          })
          .finally(() => {
            this.loading = false;
          });
      },
    },
    async created() {
      await this.fetchSchools(this.pagination.page);
    },
    watch: {
      filters: {
        deep: true,
        handler() {
          this.fetchSchools(1);
        },
      },
      schoolSelected: {
        immediate: true,
        handler(val) {
          this.$emit('input', val);
        },
      },
      'pagination.sortBy': {
        handler(oldVal, newVal) {
          if (newVal !== oldVal) {
            this.fetchSchools(1);
          }
        },
      },

    },
  };
</script>
